import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.classList.remove('hide');
    this.element.src = this.element.dataset.path;
  }
}
